<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" sm="12" md="12" xs="12">
        <b-card-group deck>
            <b-card header="All Loans">
                <p v-if="loading" style="text-align: center;padding: 20px">
                    <span style="font-size: 25px;">
                        <i class="fa fa-spinner fa-spin"></i> Loading...
                    </span>
                </p>
                <div else>
                    <div v-if="loans.length < 1">
                        <p style="font-size: 15px;" class="text-center">
                            <i>There are currently no approved loans at this moment.</i>
                        </p>
                    </div>
                    <div v-else>
                        <v-client-table :data="tableData" :columns="columns" :options="options">
                            <b-link slot="actions" slot-scope="props" to="#" @click="viewLoanDetails(props.row.actions)"><i class="fa fa-eye"> </i> View Details</b-link>
                            <div slot="status" slot-scope="props">
                                <b-badge v-show="props.row.status === 3" variant="success" pill>Accepted</b-badge>
                                <b-badge v-show="props.row.status === 4" variant="primary" pill>Awaiting Disbursement</b-badge>
                                <b-badge v-show="props.row.status === 5" variant="success" pill>Disbursed</b-badge>
                                <b-badge v-show="props.row.status === 2" variant="warning" pill>Approved</b-badge>
                                <b-badge v-show="props.row.status === 1" variant="warning" pill>Pending</b-badge>
                                <b-badge v-show="props.row.status === 6" variant="danger" pill>Declined</b-badge>
                            </div>
                        </v-client-table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <div class="pagination">
                            <span @click="getPaginated(1)">&laquo;</span>
                                <strong v-for="(number,index) in pageNumbers" :key="index" @click="getPaginated(number)">
                                    <span v-if="number === 1 || number === total_pages || (number >= current_page - 2 && number <= current_page + 2)">{{number}}</span>
                                </strong>
                            <span @click="getPaginated(last_page)">&raquo;</span>
                        </div>
                    </div>
                </div>
            </b-card>
        </b-card-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { baseURL } from '../../shared/utils';
import { mapState, mapActions } from 'vuex';
import {allLoans} from '@/services/loanService';

export default {
    name: 'allloans',
    data: () => {
        return {
            columns: ['name', 'type', 'reason', 'amount', 'status', 'date', 'actions'],
            tableData: [],
            per_page: 20,
            last_page: 0,
            total_pages: 0,
            current_page: 0,
            pageNumbers: [],
            loading: false,
            options: {
                headings: {
                    name: 'Customer Name',
                    type: 'Loan Type',
                    reason: 'Loan Reason',
                    amount: 'Amount(₦)',
                    status: 'Status',
                    date: 'Date',
                    actions: 'View Details'
                },
                sortable: ['name', 'status', 'date', 'status'],
                filterable: ['name', 'amount']
            }
        }
    },
    created () {
        this.fetchData(1);
    },
    methods: {
        async fetchData(page_number) {
            this.loading = true;
            try {
                this.tableData = [];
                let {data:{datas}} = await allLoans(page_number);
                const loans = datas.data;
                this.setData(datas);

                loans.map((loan, index) => {
                    this.tableData.push({
                        id: ++index,
                        name: `${loan.user.first_name} ${loan.user.last_name}`,
                        type: loan.loan_type.name,
                        reason: loan.loan_reason.name,
                        amount: `₦${parseInt(loan.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`,
                        status: loan.loan_status_id,
                        date: loan.application_date,
                        actions: loan.id
                    });
                });
            }
            catch(error) {
                console.log(error);
            }
            finally {
                this.loading = false;
            }
        },
        viewLoanDetails(id) {
            this.$router.push(`/loans/${id}`);
        },
        getPaginated(page_number) {
            this.fetchData(page_number);
        },
        setData(data) {
            let total_pages, last_page, current_page;
            let page_numbers = [];

            if(data) {
                total_pages = data.total;
                last_page = data.last_page;
                current_page = data.current_page;
            }
            else {
                total_pages = 0;
                last_page = 0;
                current_page = 0;
            }

            for (let i = 1; i <= Math.ceil(total_pages / data.per_page); i++) {
                page_numbers.push(i);
            }

            this.current_page = current_page;
            this.total_pages = total_pages;
            this.last_page = last_page;
            this.pageNumbers = page_numbers;
        },
    }
}
</script>

<style scoped>
    .pagination {
        margin-top: 25px;
    }

    .pagination span {
        cursor: pointer;
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        border: 1px solid #ddd;
    }

    .pagination span.active {
        background-color: #15974b;
        color: white;
        border: 1px solid #15974b;
    }
</style>
